import simpleLightbox from "simple-lightbox";
import Component from "../../lib/Component.js";
import ScrollInView from "./ScrollInView.js";

const MoviePicturesLightbox = ({ picturesSelector }) => {
  const containers = Array.from(document.querySelectorAll(picturesSelector));
  const imageLinks = containers.flatMap((container) => Array.from(container.querySelectorAll("a")));

  if (imageLinks.length === 0) {
    return Component.noop();
  }

  return ScrollInView({
    componentName: "MoviePicturesLightbox",
    observables: containers,
    disconnectOnFirst: true,
    onEnter: () => {
      new simpleLightbox({ elements: imageLinks });
    },
  });
};

export default MoviePicturesLightbox;
